import constants from '../../../../common/constants';

export const videos = {
  en: [
    {
      url: 'https://www.youtube.com/embed/JLpB1mAzA_c',
      name: 'VIDEOS.SOCIAL_TRADING',
    },
    {
      url: 'https://www.youtube.com/embed/kbpBDUt-n18',
      name: 'VIDEOS.INTEREST_CFD',
    },
    {
      url: 'https://www.youtube.com/embed/okMPI9xASe8',
      name: 'VIDEOS.NAGA_RADAR',
    },
  ],
  de: [
    {
      url: 'https://www.youtube.com/embed/e6QV8yLZDQE',
      name: 'VIDEOS.SOCIAL_TRADING',
    },
    {
      url: 'https://www.youtube.com/embed/N_e47ZGiP8Y',
      name: 'VIDEOS.INTEREST_CFD',
    },
  ],
  cz: [
    {
      url: 'https://www.youtube.com/embed/0WP2wIX3bTQ',
      name: 'VIDEOS.SOCIAL_TRADING',
    },
  ],
  es: [
    {
      url: 'https://www.youtube.com/embed/H4-YsNhzs5A',
      name: 'VIDEOS.SOCIAL_TRADING',
    },
  ],
  pl: [
    {
      url: 'https://www.youtube.com/embed/XUjRIddwqNQ',
      name: 'VIDEOS.SOCIAL_TRADING',
    },
  ],
  it: [
    {
      url: 'https://www.youtube.com/embed/xlQsWICIBgs',
      name: 'VIDEOS.SOCIAL_TRADING',
    },
  ],
  ms: [
    {
      url: 'https://www.youtube.com/embed/e7RPxxtkSOA',
      name: 'VIDEOS.SOCIAL_TRADING',
    },
  ],
};

export const videos_langugages = [
  constants.languages.en,
  constants.languages.de,
  constants.languages.cz,
  constants.languages.es,
  constants.languages.pl,
  constants.languages.it,
  constants.languages.ms,
];



// WEBPACK FOOTER //
// ./src/app/main/videos/constants/videos-constants.js